<div class="container">
    <div class="row">
        <div class="col-xs-10 col-sm-6 col-sm-offset-3 col-xs-offset-1">
            <ngx-slick class="carousel" [config]="slideConfig" *ngIf="selectedMonth != undefined && selectedMonth != null " (init)="slickInit($event)">
                <div ngxSlickItem *ngFor="let slide of selectedMonth.days" class="slide slide-slider__item"  >
                    <label (click)="setSelectedDay(slide,$event)" class="box-slider__item box-slider__item_{{slide.number}}  {{(slide.isToday)?'active':'' }}">
                    <input  type="radio" name="diaSlider" /><span>{{slide.name.substring(0,3)}}</span><span>{{slide.number}}</span>
                  </label>
                </div>
            </ngx-slick>
        </div>
    </div>
</div>
